import React from 'react';
import PropTypes from 'prop-types';

import GoogleSemMessage from '@stubhub/react-google-sem-message';
import {connect, ssr_wait} from '@stubhub/react-store-provider';

import controller from './controller';
import Nav from './nav';

import '../styles/index.scss';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      /**
       * Whether modal search is active.
       * NOTE - This can can be true even if style is expanded, if screen size is small enough.
       *
       */
      isModalSearchActive: false,
    };
  }

  @ssr_wait
  init() {
    const {globalRegistry} = this.context;
    const {subCategoriesContent, loadMultiLayeredMenu, loadSubCatNavContent} = this.props;
    if (globalRegistry.getFeatureValue('common.exposeExpandedNavMenu')) {
      return loadMultiLayeredMenu();
    }
    if (globalRegistry.getFeatureValue('common.enableSubCatNav') && !subCategoriesContent) {
      return loadSubCatNavContent();
    }

    return Promise.resolve();
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  /**
   * Callback Method to update the `isModalSearchActive` state variable on Header component.
   * @param isActive [boolean] The flag denoting if the Modal Search is active or not.
   *
   */
  onModalSearchActiveChanged = (isActive) => {
    this.setState({
      isModalSearchActive: isActive,
    });
  };

  render() {
    const {isModalSearchActive} = this.state;
    // Header class
    let headerCls = 'mh__container';
    headerCls += isModalSearchActive ? ' mh__container--searchActive' : '';
    const {
      screenSize,
      showSearchBarModal,
      onNavMenuStateChange,
      homepage,
      searchpage,
      categorypage,
      performerpage,
      geographypage,
      venuepage,
      langSelector,
      onlyNavSecondary,
      noNavSecondary,
      selectedCurrency,
      isSearchAutoFocus,
      showGoogleSemMessage,
    } = this.props;
    let {searchBarStyle} = this.props;
    headerCls += noNavSecondary ? ' mh__noNav' : '';

    // TODO: remove this condition once the minimal merch header has been adapted for desktop breakpoints
    if (searchBarStyle === 'modal' && screenSize !== 'small') {
      searchBarStyle = 'expanded';
    }

    return [
      <header key="header" className={`mh merch_header ${headerCls} mh__searchStyle--${searchBarStyle}`}>
        <GoogleSemMessage isFeatureOn={showGoogleSemMessage} isHomepage={homepage} />
        <Nav
          searchBarStyle={searchBarStyle}
          homepage={homepage}
          searchpage={searchpage}
          categorypage={categorypage}
          performerpage={performerpage}
          geographypage={geographypage}
          venuepage={venuepage}
          langSelector={langSelector}
          screenSize={screenSize}
          isModalSearchActive={isModalSearchActive}
          onModalSearchActiveChanged={this.onModalSearchActiveChanged}
          showSearchBarModal={showSearchBarModal}
          onNavMenuStateChange={onNavMenuStateChange}
          onlyNavSecondary={onlyNavSecondary}
          noNavSecondary={noNavSecondary}
          selectedCurrency={selectedCurrency}
          isSearchAutoFocus={isSearchAutoFocus}
        />
      </header>,
    ];
  }
}

Header.propTypes = {
  /** Style for the search bar */
  searchBarStyle: PropTypes.string.isRequired,

  /** Screen size */
  screenSize: PropTypes.string,

  /** Callback function when nav menu changes */
  onNavMenuStateChange: PropTypes.func,

  /** Whether the page is homepage */
  homepage: PropTypes.bool,

  /** Whether the search bar should autofocus */
  isSearchAutoFocus: PropTypes.bool,

  /** Whether to show the Google SEM message */
  showGoogleSemMessage: PropTypes.bool,

  /** Callback function to show the search bar modal */
  showSearchBarModal: PropTypes.func,

  /** Whether to show the language selector */
  langSelector: PropTypes.bool,

  /** Whether to show only the secondary nav */
  onlyNavSecondary: PropTypes.bool,

  /** Whether to show no secondary nav */
  noNavSecondary: PropTypes.bool,

  /** The selected currency */
  selectedCurrency: PropTypes.string,

  /** Callback function to load sub category nav content */
  loadSubCatNavContent: PropTypes.func,

  /** Callback function to load multi layered menu */
  loadMultiLayeredMenu: PropTypes.func,

  /** Sub category nav content */
  subCategoriesContent: PropTypes.array,

  /** Whether the page is search page */
  searchpage: PropTypes.bool,

  /** Whether the page is category page */
  categorypage: PropTypes.bool,

  /** Whether the page is performer page */
  performerpage: PropTypes.bool,

  /** Whether the page is geography page */
  geographypage: PropTypes.bool,

  /** Whether the page is venue page */
  venuepage: PropTypes.bool,
};

Header.defaultProps = {
  searchBarStyle: 'expanded',
  screenSize: __CLIENT__ ? 'small' : 'medium',
};

Header.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default connect(controller)(Header);
